import { render, staticRenderFns } from "./SftpDetailsDialog.vue?vue&type=template&id=8cf3b916&scoped=true&"
import script from "./SftpDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./SftpDetailsDialog.vue?vue&type=script&lang=js&"
import style0 from "./SftpDetailsDialog.vue?vue&type=style&index=0&id=8cf3b916&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cf3b916",
  null
  
)

export default component.exports